import Autolinker from 'autolinker';
import sanitizeHtml from 'sanitize-html';
import {DomainObject} from 'shared/store';
import { observable, computed, makeObservable } from 'mobx';
import {fullName} from 'shared/tools';
import {Employee} from 'main/stores/employees';
import {AttachedDocument} from 'main/stores/documents';
import {User} from '../users';
import {auth} from 'main/tools';

class Task extends DomainObject {
  completeToggled;
  name = '';
  description = '';
  dueDate;
  taskType;
  completed;
  subjectEmployee = {};
  assigneeEmployee = {};
  assigneeUser = {};
  relatedTo;
  attachedFiles = [];

  _relations = {
    assigneeEmployee: Employee,
    assigneeUser: User,
    subjectEmployee: Employee,
    attachedFiles: [AttachedDocument]
  };

  constructor(other) {
    super();

    makeObservable(this, {
      completeToggled: observable,
      name: observable,
      description: observable,
      dueDate: observable,
      taskType: observable,
      completed: observable,
      subjectEmployee: observable,
      assigneeEmployee: observable,
      assigneeUser: observable,
      relatedTo: observable,
      attachedFiles: observable,
      training: computed,
      assigneeName: computed,
      subjectName: computed,
      assignedToCurrentUser: computed,
      assignee: computed,
      sanitizedDescription: computed
    });

    this.merge(other);
  }

  get training() {
    return this.taskType === 'training';
  }

  get assigneeName() {
    return fullName(this.assignee);
  }

  get subjectName() {
    return fullName(this.subjectEmployee);
  }

  get assignedToCurrentUser() {
    if (this.assigneeEmployee?.id) {
      return auth.employee.id == this.assigneeEmployee.id;
    } else {
      return auth.user.id == this.assigneeUser.id;
    }
  }

  get assignee() {
    return this.assigneeEmployee || this.assigneeUser;
  }

  get sanitizedDescription() {
    const anchorText = Autolinker.link(this.description, {
      email: false,
      phone: false,
      stripPrefix: false,
      stripTrailingSlash: false,
      className: 'dodger'
    });

    return {
      __html: sanitizeHtml(anchorText, {
        allowedTags: ['a', 'strong', 'p'],
        allowedClasses: {
          a: ['dodger']
        },
        allowedAttributes: {
          a: ['href', 'target', 'className']
        }
      })
    };
  }
}

export default Task;
